import { RouterProvider } from "react-router-dom"
import { router } from "./app/routes/utbyggnadsportalen/routes"

function App() {
  return (
    <>
      <RouterProvider router={router} />
    </>
  )
}

export default App
